import * as Enumerable from 'linq';
var DrawDateHelper = /** @class */ (function () {
    function DrawDateHelper() {
    }
    DrawDateHelper.calculateNextDrawDate = function (isCustom, draw, useSalesCloseTime, sunday, monday, tuesday, wednesday, thursday, friday, saturday, drawDate, ticketSalesClosingTime) {
        var nextDraw = drawDate ? new Date(drawDate) : new Date();
        if (useSalesCloseTime) {
            var now = new Date();
            var salesClose = ticketSalesClosingTime ? new Date(ticketSalesClosingTime) : new Date();
            if (nextDraw.getDate() < now.getDate() || (nextDraw.getDate() == now.getDate() && now.getTime() > salesClose.getTime())) {
                draw += 1;
            }
        }
        var matches = {};
        matches['Sunday'] = sunday;
        matches['Monday'] = monday;
        matches['Tuesday'] = tuesday;
        matches['Wednesday'] = wednesday;
        matches['Thursday'] = thursday;
        matches['Friday'] = friday;
        matches['Saturday'] = saturday;
        var matchesEnumerable = Enumerable.from(matches);
        if (!matchesEnumerable.any(function (x) { return x.value; })) {
            //error
        }
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        if (draw == 1) // this means next draw
         {
            if (!isCustom)
                return nextDraw;
            var dayString = days[nextDraw.getDay()];
            if (matches[dayString]) {
                return nextDraw;
            }
            else {
                draw = 2;
            }
        }
        if (!Enumerable.from(matches).any(function (x) { return x.value; }))
            return null;
        // loop in number of draws
        for (var i = 2; i <= draw; i++) {
            var computed = false;
            do {
                nextDraw.setDate(nextDraw.getDate() + 1);
                var dayString = days[nextDraw.getDay()];
                if (matches[dayString]) {
                    computed = true;
                }
            } while (!computed);
        }
        return this.calculateNextDrawDate(isCustom, 1, useSalesCloseTime, sunday, monday, tuesday, wednesday, thursday, friday, saturday, nextDraw, ticketSalesClosingTime);
    };
    return DrawDateHelper;
}());
export { DrawDateHelper };
